export default {"src":"/_next/static/media/checkmarkWhite_14x11.45fcaf2a.svg","height":11,"width":14,"blurWidth":0,"blurHeight":0};